function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_7028_146)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M13.0758 7.19808C13.1699 6.95847 13.311 6.76677 13.4991 6.57508C13.6873 6.40735 13.8754 6.26358 14.1106 6.16773C14.3458 6.07188 14.581 6 14.8397 6C15.0984 6 15.3571 6.04792 15.5923 6.16773C15.8275 6.26358 16.0392 6.40735 16.2038 6.57508C16.392 6.74281 16.5331 6.95847 16.6272 7.19808C16.7213 7.4377 16.7918 7.70128 16.7918 7.96486C16.7918 8.22843 16.7448 8.49201 16.6272 8.73163C16.5331 8.97125 16.392 9.1869 16.2274 9.35463C16.0627 9.54633 15.851 9.6901 15.6159 9.78594C15.3807 9.88179 15.122 9.95367 14.8632 9.92971C14.6045 9.92971 14.3458 9.88179 14.1106 9.78594C13.6402 9.57029 13.2875 9.21086 13.0758 8.73163C12.9817 8.46805 12.9111 8.20447 12.9111 7.94089C12.9347 7.67732 12.9817 7.41374 13.0758 7.19808ZM18.25 21H11.5V19.4185C12.5819 19.4185 13.1228 19.131 13.1228 18.5559V13.5479C13.1228 12.9489 12.5819 12.6613 11.5 12.6613V11.1038H16.6272V18.5319C16.6037 19.107 17.1446 19.4185 18.25 19.4185V21Z",
  fill: "#69696C"
}));

var _ref3 = /*#__PURE__*/React.createElement("circle", {
  cx: 14.5,
  cy: 14,
  r: 13.6216,
  stroke: "#69696C",
  strokeWidth: 0.756757
});

var _ref4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_7028_146"
}, /*#__PURE__*/React.createElement("rect", {
  width: 6.75,
  height: 15,
  fill: "white",
  transform: "translate(11.5 6)"
})));

var SvgInfo = function SvgInfo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 28,
    viewBox: "0 0 29 28",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgInfo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/info.e71b00ff.svg";
export { ForwardRef as ReactComponent };